import React from 'react';
import { Box } from '@mui/system';
import PieChartIcon from '@mui/icons-material/PieChart';
import Typography from '@mui/material/Typography';
import ErrorIcon from '@mui/icons-material/Error';
import useStyles from './styles';
import { Grid } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';

/**
 * @name SplitVisualizerIcon
 * @description This clickable icon should be used to open the visualizer modal
 * @param {object[]} data - [{id:string,value:string,label:string}]
 * @param {number} sumRes
 * @param {function} updateModalContent
 */
const SplitVisualizerIcon = ({ data, sumRes, updateModalContent }) => {
	const classes = useStyles();

	let containsNegetiveNumber = false;

	const totalSum = data.reduce((prev, cur) => {
		if (cur.value < 0) {
			containsNegetiveNumber = true;
		}
		prev += cur.value;
		return prev;
	}, 0);

	const isValidSum = totalSum === sumRes && !containsNegetiveNumber;

	const handleVisualizerIconClicked = () => {
		if (!isValidSum) {
			return;
		}
		updateModalContent(<PieChartVisualizer data={data} />);
	};

	return (
		<Box style={{ display: 'flex' }} onClick={handleVisualizerIconClicked}>
			{isValidSum ? (
				<>
					<PieChartIcon
						className={classes.icon}
						fontSize="medium"
						style={{ margin: '0 auto', paddingTop: '.5rem', marginRight: '1rem', color: 'green' }}
					/>
					<Typography
						className={classes.heading}
						fontWeight={600}
						variant="h6"
						style={{ color: 'green', cursor: 'pointer' }}
					>
						Visualize Split
					</Typography>
				</>
			) : (
				<>
					<ErrorIcon
						className={classes.icon}
						color="primary"
						fontSize="medium"
						style={{ margin: '0 auto', paddingTop: '.5rem', marginRight: '1rem' }}
					/>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						SPLIT IS INCORRECT
					</Typography>
				</>
			)}
		</Box>
	);
};

const PieChartVisualizer = React.forwardRef(({ data }) => {
	const classes = useStyles();

	return (
		<Grid container spacing={2} className={classes.modalContentStyle}>
			<Grid item xs={6}>
				<Typography className={classes.heading} fontWeight={600} variant="h4">
					Split Visualizer
				</Typography>
			</Grid>
			<Grid item xs={12}>
				<PieChart
					series={[
						{
							arcLabel: (item) => `${item.value}%`,
							data: data,
							outerRadius: 150,
							cornerRadius: 5,
							highlightScope: { faded: 'global', highlighted: 'item' },
							faded: { innerRadius: 30, additionalRadius: -30 },
							cx: 150,
							cy: 180
						}
					]}
					sx={{
						'--ChartsLegend-rootOffsetX': '-100px'
					}}
					tooltip={{}}
					width={600}
					height={400}
				/>
			</Grid>
		</Grid>
	);
});

export default SplitVisualizerIcon;